
import React, { PureComponent } from 'react'
import { Button, Modal, Col } from 'react-bootstrap'
import { Field, reduxForm } from 'redux-form'
import InputText from '../../commons/form/InputText'
import InputSelect from '../../commons/form/InputSelect'
import InputCheckBox from '../../commons/form/InputCheckBox'
import { handleKeyDown } from '../../../util/utils'

class OrganizedUnitModal extends PureComponent {
  constructor () {
    super()
    this.state = {
      idUo: null
    }
  }

  submitOrganizedUnit (values) {
    this.props.actions.saveOrganizedUnitModal(values, this.props.organizedUnitFields.organizedUnitId)
  }

  handleParentOUChange (value) {
    if (this.props.organizedUnitId === undefined || this.props.organizedUnitId === null) {
      this.props.actions.fetchProcessingAgencyCombo(value)
    }
  }

  componentDidUpdate () {
    if (this.props.organizedUnitId !== undefined && this.props.organizedUnitId !== null && this.props.organizedUnitId !== this.state.idUo) {
      this.props.actions.fetchProcessingAgencyCombo(this.props.organizedUnitId)
      this.props.actions.fetchSameLevelOusCombo(this.props.organizedUnitId, null)
      this.setState({ idUo: this.props.organizedUnitId })
    }
  }

  render () {
    const {
      t, showOrganizedUnitModal, handleSubmit,
      combos: { organizedUnitsAllCombo, legalCompanyCombo, directionOUCombo, countriesCombo, processingAgencyCombo, destinationCombo }
    } = this.props
    const tKey = 'MASTERS.OU_MASTERS.'
    return (
      <Modal id="organizedUnitModal" show={showOrganizedUnitModal} onHide={this.props.actions.closeOrganizedUnitModal} className="_nf" backdrop={'static'}>
        <Modal.Header closeButton>
          <Modal.Title>{t(`${tKey}SOURCE_CHANNEL`)}</Modal.Title>
        </Modal.Header>
        <form autoComplete="off" onSubmit={ handleSubmit((values) => this.submitOrganizedUnit(values))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Body>
            <div className="search-form">
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                id="code"
                name="code"
                controlLabel={t(`${tKey}UOCODE`)}
                placeholder={t(`${tKey}UOCODE`)}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                id="name"
                name="name"
                controlLabel={t(`${tKey}NAME`)}
                placeholder={t(`${tKey}NAME`)}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                id="brand"
                name="brand"
                controlLabel={t(`${tKey}BRAND`)}
                placeholder={t(`${tKey}BRAND`)}
              />
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                id ="legalCompanyId"
                name="legalCompanyId"
                controlLabel={t(`${tKey}LEGAL_COMPANY`)}
                placeholder={t(`${tKey}LEGAL_COMPANY`)}
                valueKey="id"
                labelKey="value"
                options={legalCompanyCombo}
              />
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                id="parentOrganizedUnitId"
                name="parentOrganizedUnitId"
                controlLabel={t(`${tKey}PARENT_OU`)}
                placeholder={t(`${tKey}PARENT_OU`)}
                valueKey="id"
                labelKey="value"
                onInputChange={(value) => this.handleParentOUChange(value)}
                options={ organizedUnitsAllCombo && organizedUnitsAllCombo.filter(x => x.id !== this.props.organizedUnitId) }
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                id="notificationMails"
                name="notificationMails"
                controlLabel={t(`${tKey}NOTIFICATION_MAILS`)}
                placeholder={t(`${tKey}NOTIFICATION_MAILS`)}
              />
              <Field
                component={InputSelect}
                colWidth={66} // 25, 33, 50, 75, 100 default=25
                id="directionUOId"
                name="directionUOId"
                controlLabel={t(`${tKey}DIRECTION_OU`)}
                placeholder={t(`${tKey}DIRECTION_OU`)}
                valueKey="id"
                labelKey="value"
                options={directionOUCombo}
              />
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                id="countryId"
                name="countryId"
                controlLabel={t(`${tKey}COUNTRY`)}
                placeholder={t(`${tKey}COUNTRY`)}
                valueKey="countryId"
                labelKey="code"
                options={countriesCombo}
              />
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                id="defaultProcessingAgencyId"
                name="defaultProcessingAgencyId"
                controlLabel={t(`${tKey}PROCESSING_AGENCY`)}
                placeholder={t(`${tKey}PROCESSING_AGENCY`)}
                valueKey="id"
                labelKey="value"
                options={processingAgencyCombo}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                id="accounts"
                name="accounts"
                controlLabel={t(`${tKey}ACCOUNTS`)}
                placeholder={t(`${tKey}ACCOUNTS`)}
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                id="documentLogoName"
                name="documentLogoName"
                controlLabel={t(`${tKey}DOCUMENT_LOGO`)}
                placeholder={t(`${tKey}DOCUMENT_LOGO`)}
              />
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="defaultDestinationId"
                controlLabel={t(`${tKey}DESTINY`)}
                placeholder={t(`${tKey}DESTINY`)}
                valueKey="id"
                labelKey="value"
                options={destinationCombo}
              />
            </div>
            <div className="search-form">
              <Field
                component={InputCheckBox}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="acceptsClients"
                controlLabel={t(`${tKey}ACCEPTS_CLIENTS`)}
                placeholder={t(`${tKey}ACCEPTS_CLIENTS`)}
              />
              <Field
                component={InputCheckBox}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="acceptsVehicles"
                controlLabel={t(`${tKey}ACCEPTS_VEHICLES`)}
                placeholder={t(`${tKey}ACCEPTS_VEHICLES`)}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Col className="flexInLine al-R">
              <Button type="submit" className="_Btn new" disabled={this.props.pristine}>
                {t('MASTERS.SAVE')}
              </Button>
            </Col>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

const validate = (values, props) => {
  const errors = {}
  if (values) {
    const tKey = 'MASTERS.OU_MASTERS.VALIDATION.'
    if (!values.code || values.code.length > 10) {
      errors.code = props.t(`${tKey}CODE`)
    }
    if (!values.name) {
      errors.name = props.t(`${tKey}NAME`)
    }
    if (!values.brand) {
      errors.brand = props.t(`${tKey}BRAND`)
    }
    if (!values.parentOrganizedUnitId) {
      errors.parentOrganizedUnitId = props.t(`${tKey}PARENT_OU`)
    }
  }

  return errors
}

export default reduxForm({
  form: 'editOrganizedUnit',
  validate
})(OrganizedUnitModal)
